import * as SharedDocumentActions from "./sharedDocumentActions";

export default SharedDocumentActions;
